export var ProfessionalProfile;
(function (ProfessionalProfile) {
    ProfessionalProfile["SOCIO"] = "SOCIO";
    ProfessionalProfile["ADVOGADO_ASSOCIADO"] = "ADVOGADO_ASSOCIADO";
    ProfessionalProfile["ADVOGADO_CELETISTA"] = "ADVOGADO_CELETISTA";
    ProfessionalProfile["ADVOGADO_AUTONOMO"] = "ADVOGADO_AUTONOMO";
    ProfessionalProfile["BACHAREL"] = "BACHAREL";
    ProfessionalProfile["ESTAGIARIO"] = "ESTAGIARIO";
    ProfessionalProfile["TRAINEE"] = "TRAINEE";
    ProfessionalProfile["ADMINISTRATIVO"] = "ADMINISTRATIVO";
    ProfessionalProfile["FINANCEIRO"] = "FINANCEIRO";
})(ProfessionalProfile || (ProfessionalProfile = {}));
